<div class="container-fluid" [formGroup]="group">
    <div class="section">
        <h4 class="section-title">Plan Settings</h4>
        <div class="section-description">
            {{'Set required information associated with your new plan'}}
        </div>
    </div>
    <hr>

    <div class="container-fluid">
        <div class="row">
            <!--PLAN NAME-->
            <div class="col-6 border-right" id="DL-name">
                <label class="font-weight-bold">{{'PLAN NAME'}}</label>
                <acl-ngx-input [error]="name.touched && name.errors" variant="table" formControlName="name"
                    placeholder="Enter"></acl-ngx-input>
                <div *ngIf="name.touched && name.errors" class="error-feedback">
                    <span>Plan Name cannot be empty</span>
                </div>
            </div>
            <!--PLAN ID-->
            <div class="col border-right" *ngIf="!isNew && !isCopy">
                <label class="font-weight-bold">{{'ID'}}</label>
                <div class="pt-2">{{ group.controls.id.value }}</div>
            </div>
            <!--LABEL-->
            <div class="col">
                <labels [group]="group" [advertiserInfo]="advertiserInfo"></labels>
            </div>
        </div>
        <hr>

        <div class="row">
            <!--FORMAT-->
            <div class="col format-container border-right hide-chip-close-button" id="DL-channels">
                <label class="font-weight-bold">{{'FORMAT'}}</label>
                <!-- <ng-multiselect-dropdown [ngClass]="{ 'error': channelControl.touched && channelControl.errors }"
                    [placeholder]="'Add Formats'" [data]="channels" [settings]="dropdownSettings"
                    (onDeSelect)="onItemSelect($event)" (onSelect)="onItemSelect($event)"
                    (onDeSelectAll)="onItemSelect($event)" [(selectedData)]="selectedChannels" disabled="true">
                </ng-multiselect-dropdown> -->
                <!--<div class="margin-top-5">
                    <span class="chip-container" *ngFor="let channel of selectedChannels">
                        <acl-ngx-chip [text]="channel.text"></acl-ngx-chip>
                    </span>
                </div>-->
                <div *ngFor="let channel of selectedChannels" class="m-2">
                    {{channel.text}}
                </div>
                <div *ngIf="channelControl.touched && channelControl.errors" class="error-feedback">
                    <span>Format cannot be empty, at least one format must be selected</span>
                </div>
            </div>
            <!--FLIGHT SCHEDULE-->
            <div class="col">
                <flight-schedule [group]="group.get('flightSchedule')" [isNew]="isNew"
                    [advertiserInfo]="advertiserInfo">
                </flight-schedule>
            </div>
        </div>
        <hr>

        <!--PLAN OBJECTIVE-->
        <!--Not supported for V1 & V2-->
        <!-- <div class="col">
                <label class="font-weight-bold">{{'PLAN OBJECTIVE'}}</label>
                <acl-ngx-input contentClass="planner-input" formControlName="objective" placeholder="Reach">
                </acl-ngx-input>
        </div> -->

        <!--LINEAR SCHEDULE: Hidden this as its not planned for CCP phase 1-->
        <!-- <div
            [ngClass]="(linearScheduleIdValue === nationalLinearScheduleEnum.uploadExistingSchedule) ? 'col border-right' : 'col'">
            <label>{{'NATIONAL LINEAR SCHEDULE'}}</label>
            <div *ngFor="let item of scheduleType">
            <label>
                <input type="radio" formControlName="linearScheduleId" [value]=item.id>
                {{item.label}}
            </label>
            </div>
        </div> -->

        <!--UPLOAD SCHEDULE: Hidden this as its not planned for CCP phase 1-->
        <!-- <div *ngIf="linearScheduleIdValue === nationalLinearScheduleEnum.uploadExistingSchedule" class="col">
            <label>{{'UPLOAD SCHEDULE'}}</label>
        </div>

        <!--BUY DEMO: Hidden this as its not planned for CCP phase 1-->
        <!-- <div *ngIf="linearScheduleIdValue === nationalLinearScheduleEnum.uploadExistingSchedule">
            <buy-demo [group]="group.get('demoSetting')"></buy-demo>
        </div> -->
    </div>
</div>